import { render } from "./addMenu.vue?vue&type=template&id=14c21554&scoped=true"
import script from "./addMenu.vue?vue&type=script&lang=js"
export * from "./addMenu.vue?vue&type=script&lang=js"

import "./addMenu.vue?vue&type=style&index=0&id=14c21554&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c21554"]])

export default __exports__